<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 19L8.5 12L15.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
